module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/scotch_51b3be.jpg";